import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { PageFooter as SharedPageFooter } from '@make-software/tg-mini-app-ui';

import { EARN_PATH, FRIENDS_PATH, HOME_PATH, LEADERBOARD_PATH, RANKING_PATH } from '@/app/paths';
import HomeIcon from '@/shared/assets/icons/ic-home.svg';
import RankingIcon from '@/shared/assets/icons/ic-rank-cup.svg';
import FriendsIcon from '@/shared/assets/icons/ic-friend.svg';
import EarnIcon from '@/shared/assets/icons/ic-earn.svg';
import { useMakeTrafficManager } from '@/shared';

export const PageFooter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const { tasks } = useMakeTrafficManager();
  const remainingTasksCount = tasks.filter((t) => !t.userState.isRewarded).length;
  const theme = useTheme();

  const typography = {
    label: {
      fontFamily: theme.typography.fontFamily.sans,
      fontSize: '11px',
      fontWeight: 500
    },
    badge: {
      fontFamily: theme.typography.fontFamily.sans,
      fontSize: '12px',
      fontWeight: 700
    }
  }
  return (
    <SharedPageFooter
      variant="tabs"
      typography={typography}
      currentPath={currentPath}
      colors={{ hover: '#FFF', active: '#FFF' }}
      tabs={[
        {
          path: HOME_PATH,
          iconSrc: HomeIcon,
          label: 'Home',
          onClick: () => navigate(HOME_PATH)

        },
        {
          path: RANKING_PATH,
          iconSrc: RankingIcon,
          label: 'Ranking',
          onClick: () => navigate(RANKING_PATH),
          // highlight both Drop and Leaderboard paths
          ...(currentPath === LEADERBOARD_PATH ? { path: LEADERBOARD_PATH } : {})
        },
        {
          path: FRIENDS_PATH,
          iconSrc: FriendsIcon,
          label: 'Friends',
          onClick: () => navigate(FRIENDS_PATH)
        },
        {
          path: EARN_PATH,
          iconSrc: EarnIcon,
          label: 'Earn',
          badge: remainingTasksCount > 0 ? remainingTasksCount : undefined,
          badgeBackgroundColor: theme.colors.mainRed,
          onClick: () => navigate(EARN_PATH)
        }
      ]}
    />
  );
};
